import { AsyncPipe, NgClass } from '@angular/common';
import {
  AfterViewInit,
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormControlStatus } from '@angular/forms';
import { MatFormField, MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getErrorMessage } from '../../../consts/mdc/mdc-form-field-errors';

@Component({
  selector: 'mdc-form-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, AsyncPipe, MatFormFieldModule],
  template: `
    <mat-form-field
      class="mat-mdc-form-field"
      [className]="customClass"
      [ngClass]="{
        'no-validation': noValidation,
        readonly: readonly
      }">
      @if (label) {
        <mat-label>{{ label }}</mat-label>
      }

      <ng-content />

      @if (!noValidation) {
        <mat-error>{{ errorMessage$ | async }}</mat-error>
      }
      @if (hint) {
        <mat-hint>{{ hint }}</mat-hint>
      }
    </mat-form-field>
  `
})
export class MdcFormFieldComponent<T> implements OnInit, AfterViewInit {
  @Input({ transform: booleanAttribute }) noValidation = false;
  @Input({ transform: booleanAttribute }) readonly = false;
  @Input() label = '';
  @Input() customClass = '';
  @Input() hint = '';
  @ViewChild(MatFormField, { static: true }) matFormField: MatFormField;
  @ContentChild(MatFormFieldControl, { static: true })
  matFormFieldControl: MatFormFieldControl<T>;
  errorMessage$: Observable<string>;

  ngOnInit(): void {
    this.matFormField._control = this.matFormFieldControl;
  }

  ngAfterViewInit(): void {
    // this.matFormFieldControl.ngControl may be null in exceptional cases when we need to apply the style of the
    // mat-form-field without associating a control with it
    const { control } = this.matFormFieldControl.ngControl ?? {};
    control &&
      (this.errorMessage$ = control.statusChanges.pipe(
        map((status: FormControlStatus) =>
          status === 'INVALID' && control.errors ? getErrorMessage(control.errors) : ''
        )
      ));
  }
}
